<footer>

  <div id="footer">
    <div id="inner_footer" class="fix_center_large">
      <div class="footer_contents flex_layout flex_wrap">
        <div *ngIf="lang === 'ja'" class="footerbnr">
          <ul class="footerbnrlist flex_layout">
            <li class="footerbnrbtn btn_event flex3col">
              <a href="{{ appUrl }}/event" class="shadow">
                <div class="banner_box flex_layout txtalcenter">
                  <div class="banner_photo overlay posrelative flexhalf">
                    <picture>
                      <source media="(min-width: 600px)" srcset="assets/img/footernav_event.jpg 1x, assets/img/footernav_event@2x.jpg 2x">
                      <source media="(max-width: 600px)" srcset="assets/img/footernav_event.jpg 1x, assets/img/footernav_event.jpg 2x">
                      <img src="assets/img/footernav_event.jpg" width="300" alt="CARZY LiVE イベント総合情報サイト">
                    </picture>
                  </div>
                  <div class="banner_txt flexhalf"><img src="assets/img/carzylive_ci.png" srcset="assets/img/carzylive_ci.png 1x, assets/img/carzylive_ci@2x.png 2x" width="210" alt="CARZY LiVE　イベント総合情報サイト"><span class="banner_sub_txt">イベント総合情報</span></div>
                </div>
              </a>
            </li>
            <li class="footerbnrbtn btn_photo flex3col">
              <a href="{{ appUrl }}/photo" class="shadow">
                <div class="banner_box flex_layout txtalcenter">
                  <div class="banner_photo overlay posrelative flexhalf">
                    <picture>
                      <source media="(min-width: 600px)" srcset="assets/img/footernav_photo.jpg 1x, assets/img/footernav_photo@2x.jpg 2x">
                      <source media="(max-width: 600px)" srcset="assets/img/footernav_photo.jpg 1x, assets/img/footernav_photo.jpg 2x">
                      <img src="assets/img/footernav_photo.jpg" width="300" alt="PHOTO ALBUM イベントレポート">
                    </picture>
                  </div>
                  <div class="banner_txt flexhalf"><img src="assets/img/photoalbum_ci.png" srcset="assets/img/photoalbum_ci.png 1x, assets/img/photoalbum_ci@2x.png 2x" width="210" alt="PHOTO ALBUM　イベントレポート"><span class="banner_sub_txt">イベントレポート</span></div>
                </div>
              </a>
            </li>
            <li class="footerbnrbtn btn_mag flex3col">
              <a href="{{ appUrl }}/magazine" class="shadow">
                <div class="banner_box flex_layout txtalcenter">
                  <div class="banner_photo overlay posrelative flexhalf">
                    <picture>
                      <source media="(min-width: 600px)" srcset="assets/img/footernav_czmag.jpg 1x, assets/img/footernav_czmag@2x.jpg 2x">
                      <source media="(max-width: 600px)" srcset="assets/img/footernav_czmag.jpg 1x, assets/img/footernav_czmag.jpg 2x">
                      <img src="assets/img/footernav_czmag.jpg" width="300" alt="CZ MAG Webマガジン">
                    </picture>
                  </div>
                  <div class="banner_txt flexhalf"><img src="assets/img/czmag_ci.png" srcset="assets/img/czmag_ci.png 1x, assets/img/czmag_ci@2x.png 2x" width="210" alt="CZ MAG　WEBマガジン"><span class="banner_sub_txt">WEBマガジン</span></div>
                </div>
              </a>
            </li>
          </ul>
        </div>
        <div class="footerci txtalcenter">
          <div class="carzyci hash_nav"><a href="{{ appUrl }}" title="CARZY"><img src="assets/img/carzy_ci.png" srcset="assets/img/carzy_ci.png 1x, assets/img/carzy_ci@2x.png 2x" width="120" alt="{{ lang | i18nSelect: strings.nav.subTitle }}"></a></div>
          <div class="bcopy">{{ lang | i18nSelect: strings.nav.subTitle }}</div>
          <div class="snsnav">
            <ul class="snsnavlist flex_layout">
              <li class="snsnavbtn btn_fb"><a href="https://www.facebook.com/CARZY.net/" rel="noopener noreferrer" target="_blank"><img src="assets/img/btn_fb.png?v=3" alt="CARZY Facebook" width="30"></a></li>
              <li class="snsnavbtn btn_tw"><a href="https://twitter.com/CARZY_net" rel="noopener noreferrer" target="_blank"><img src="assets/img/btn_tw.png" alt="CARZY Twitter" width="30"></a></li>
              <li class="snsnavbtn btn_insta"><a href="https://www.instagram.com/carzy_net/" rel="noopener noreferrer" target="_blank"><img src="assets/img/btn_insta.png" alt="CARZY Instagram" width="30"></a></li>
            </ul>
          </div>
        </div>
        <div class="footernav">
          <ul class="footernavlist servicenav flex_layout flex_wrap hash_nav" id="nav" data-unnecessary-close-button="true">
            <li class="footernavbtn btn_about"><a href="{{ appUrl }}/about-carzy">{{ lang | i18nSelect: strings.nav.about }}</a></li>
            <li class="footernavbtn btn_stocklist"><a href="{{ appUrl }}/cars">{{ lang | i18nSelect: strings.nav.stockList }}</a></li>
            <li class="footernavbtn btn_selling"><a href="{{ appUrl }}/selling">{{ lang | i18nSelect: strings.nav.selling }}</a></li>
            <li class="footernavbtn btn_photo_service" *ngIf="lang == 'ja'"><a href="{{ appUrl }}/photo-service">フォトブック/ポスター作成</a></li>
            <li class="footernavbtn btn_illust_service" *ngIf="lang == 'ja'"><a href="{{ appUrl }}/illustration">イラスト作成</a></li>
            <li class="footernavbtn btn_news" *ngIf="lang == 'ja'"><a href="{{ appUrl }}/topics">最新情報</a></li>
            <li class="footernavbtn btn_inquiry"><a href="{{ appUrl }}/inquiry">{{ lang | i18nSelect: strings.nav.contact }}</a></li> 
          </ul>

          <ul class="footernavlist companynav hash_nav flex_layout flex_wrap" id="nav" data-unnecessary-close-button="true">
            <li class="footernavbtn btn_mission" *ngIf="lang=='ja'"><a href="{{ appUrl }}/article/octane">ミッションステートメント</a></li>
            <li class="footernavbtn btn_crew"><a href="{{ appUrl }}/article/crew">{{ lang | i18nSelect: strings.nav.crew }}</a></li>
            <li class="footernavbtn btn_company"><a href="{{ appUrl }}/company">{{ lang | i18nSelect: strings.nav.company }}</a></li>
            <li class="footernavbtn btn_recruit" *ngIf="lang=='ja'"><a href="https://recruit.contact.co.jp/" target="_blank">採用情報</a></li>
            <li class="footernavbtn btn_legal" *ngIf="lang=='ja'"><a href="{{ appUrl }}/law">特定商取引法表示</a></li>
            <li class="footernavbtn btn_privacy"><a href="{{ appUrl }}/privacy-policy">{{ lang | i18nSelect: strings.nav.privacyPolicy }}</a></li>
            <li class="footernavbtn btn_privacy" *ngIf="lang=='ja'"><a href="{{ appUrl }}/terms-of-service">利用規約</a></li>
          </ul>
        </div>
      </div>
      <div class="copyright langen">Copyright(C) <span class="disp_inlineblock">CARZY Inc. All Rights Reserved.</span></div>
    </div>
  </div>
</footer>
